interface StorageItem<T> {
	key: string;
	value: T;
}

type StorageType = 'local' | 'session';

class StorageManager {
	private storage: Storage;

	constructor(type: StorageType = 'session') {
		this.storage = type === 'local' ? localStorage : sessionStorage;
	}

	setItem<T>(item: StorageItem<T>): void {
		try {
			this.storage.setItem(item.key, JSON.stringify(item.value));
		} catch (error) {
			console.error('Error setting item in storage:', error);
		}
	}

	getItem<T>(key: string): T | null {
		try {
			const item = this.storage.getItem(key);
			return item ? JSON.parse(item) : null;
		} catch (error) {
			console.error('Error getting item from storage:', error);
			return null;
		}
	}

	removeItem(key: string): void {
		try {
			this.storage.removeItem(key);
		} catch (error) {
			console.error('Error removing item from storage:', error);
		}
	}

	clean(): void {
		try {
			localStorage.clear();
			sessionStorage.clear();
		} catch (error) {
			console.error('Error cleaning storage:', error);
		}
	}
}

export { StorageManager };
